// extracted by mini-css-extract-plugin
module.exports = {"subsidiaryList":"emptystate_subsidiaryList__RRny4","image":"emptystate_image__3T3lh"};